// src/pages/ForgotPassword.js
import { useState } from "react";
import { Link } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import "./Login.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleResetPassword(e) {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const functions = getFunctions();
      const sendPasswordResetEmail = httpsCallable(functions, "sendPasswordResetEmail");
      
      await sendPasswordResetEmail({ email });
      
      setMessage(
        "Password reset email sent! Please check your inbox for instructions."
      );
      setEmail("");
      
    } catch (err) {
      console.error("Password reset error:", err);
      
      if (err.code === "functions/not-found") {
        setError("Password reset service is not available. Please try again later.");
      } else if (err.message.includes("no user record")) {
        setError("No account found with this email address.");
      } else {
        setError("Unable to send reset email. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-overlay"></div>

      <div className="login-container">
        <div style={{
          fontSize: '72px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          🔐
        </div>
        <h2>Reset Password</h2>
        
        <p style={{
          color: 'rgba(255, 255, 255, 0.7)',
          textAlign: 'center',
          marginBottom: '24px',
          fontSize: '0.95rem',
          lineHeight: '1.5'
        }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleResetPassword} className="login-form">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />

          <button className="login-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          {error && <p className="login-error">{error}</p>}
          {message && (
            <p style={{
              color: '#00ff88',
              background: 'rgba(0, 255, 136, 0.1)',
              border: '1px solid rgba(0, 255, 136, 0.3)',
              padding: '12px',
              borderRadius: '8px',
              fontSize: '0.95rem',
              textAlign: 'center',
              marginTop: '16px'
            }}>
              {message}
            </p>
          )}
        </form>

        <Link to="/login" className="login-register-link">
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}